export default __webpack_public_path__ + "static/media/5243.0cb3b7fe.png";